// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-noise/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springNoiseEN: PageEntry = {
  id: "post.federgeraeusch",
  locale: "en",
  slug: "spring-noise",
  seo: {
    title: "Glossary: Spring noise explained simply | Dietz GmbH",
    description: "Spring noises are the acoustic emissions that can occur during the movement or deformation of a spring. These noises are caused by friction, vibrations or resonances in the spring ",
  },
  type: "post",
  h1: "Glossary: Spring noise explained simply",
  intro: "Spring noises are the acoustic emissions that can occur during the movement or deformation of a spring. These noises are caused by friction, vibrations or resonances in the spring or neighbouring components. In order to minimise spring noise, a precise spring design, high-quality materials and, if necessary, the use of lubricants or damping elements are required. In many applications, especially in the automotive industry, the control of spring noise is crucial for the comfort and quality of the product.",
  blocks: [

  ],
};
